//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PaginationTableau',
  props: {
    limit: {
      type: Number,
      default: 10
    },
    page: {
      type: Number,
      default: 0
    },
    rows: {
      type: Number,
      default: 0
    }
  },
  computed: {
    totalPage: function totalPage() {
      return Math.ceil(this.rows / this.limit);
    },
    disabledFirst: function disabledFirst() {
      return this.page === 1;
    },
    disabledLast: function disabledLast() {
      return this.totalPage === this.page;
    }
  },
  methods: {
    onPrevious: function onPrevious() {
      this.$emit('onPage', this.page - 1);
    },
    onNext: function onNext() {
      this.$emit('onPage', this.page + 1);
    }
  }
};